import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CChartEventSearchPage } from "src/components/views/spc/cChartEvents/searchView/CChartEventSearchPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/cChartEvents/search")({
	staticData: { title: i18n.t("events"), legacyViewKey: "cChartEventSearchPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CChartEventSearchPage />;
}
